<script lang="ts">
	import { loadingAuxillaryBalance } from '$lib/home/store';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import ProcessingIcon from '$lib/util/ProcessingIcon.svelte';
	import { addingSmartContractWalletAuthorities } from '$lib/wallet/store';
	import { addSmartContractWalletAuthority, openAddAuthorityConfirmationModal } from '../scWallet';
	import { authorityAddressToAdd } from '../store';
</script>

<div class="flex gap-2">
	<div class="w-full">
		<Tooltip
			title="This account will have same authority as your account. Please note that every authority has access to remove any other authority."
			header="New Authority address"
		>
			<input
				bind:value={$authorityAddressToAdd}
				type="text"
				placeholder="Address of the new authority to trade."
				class="border border-fx-grey-500 px-3 py-1 rounded-lg squircle-lg w-full bg-transparent text-fx-grey-300 font-medium text-sm"
			/>
		</Tooltip>
	</div>
	{#if $addingSmartContractWalletAuthorities}
		<button
			class="bg-fx-grey-600 text-fx-grey-300 font-semibold text-center py-2 rounded-lg squircle-xl hover:bg-opacity-60 hover:text-fx-grey-200 transition duration-200 px-4 whitespace-nowrap sm:w-fit text-xs flex cursor-not-allowed gap-2 items-center"
		>
			<ProcessingIcon />
			<div>Adding</div>
		</button>
	{:else if ['', undefined].includes($authorityAddressToAdd)}
		<button
			class="bg-fx-grey-600 text-fx-grey-300 font-semibold text-center py-2 rounded-lg squircle-xl hover:bg-opacity-60 hover:text-fx-grey-200 transition duration-200 px-4 whitespace-nowrap sm:w-fit text-xs flex cursor-not-allowed gap-2 items-center"
		>
			Add Authority
		</button>
	{:else}
		<button
			class="bg-fx-blue text-fx-grey-100 font-semibold text-center py-2 rounded-lg squircle-xl hover:bg-opacity-60 hover:text-fx-grey-200 transition duration-200 cursor-pointer px-4 whitespace-nowrap sm:w-fit text-xs"
			on:click={openAddAuthorityConfirmationModal}>Add Authroity</button
		>
	{/if}
</div>
